// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { HostWithRelationsSchema } from './HostRelationsSchema'
import type { HostWithRelations } from './HostRelationsSchema'
import { GatewayWithRelationsSchema } from './GatewayRelationsSchema'
import type { GatewayWithRelations } from './GatewayRelationsSchema'
import { ProbeArtifactSchema } from './ProbeArtifactSchema'
import type { ProbeArtifact } from './ProbeArtifactSchema'
import { SoftwareWithRelationsSchema } from './SoftwareRelationsSchema'
import type { SoftwareWithRelations } from './SoftwareRelationsSchema'
import { VhostBindingWithRelationsSchema } from './VhostBindingRelationsSchema'
import type { VhostBindingWithRelations } from './VhostBindingRelationsSchema'
import { NetworkServiceSchema } from './NetworkServiceSchema';

/////////////////////////////////////////
// NETWORK SERVICE RELATION SCHEMA
/////////////////////////////////////////

export type NetworkServiceRelations = {
  surface: ExternalNetworkWithRelations;
  host?: HostWithRelations | null;
  gateway?: GatewayWithRelations | null;
  probeArtifacts: ProbeArtifact[];
  software: SoftwareWithRelations[];
  vhostBindings: VhostBindingWithRelations[];
};

export type NetworkServiceWithRelations = z.infer<typeof NetworkServiceSchema> & NetworkServiceRelations

export const NetworkServiceWithRelationsSchema: z.ZodType<NetworkServiceWithRelations> = NetworkServiceSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  host: z.lazy(() => HostWithRelationsSchema).nullable(),
  gateway: z.lazy(() => GatewayWithRelationsSchema).nullable(),
  probeArtifacts: z.lazy(() => ProbeArtifactSchema).array(),
  software: z.lazy(() => SoftwareWithRelationsSchema).array(),
  vhostBindings: z.lazy(() => VhostBindingWithRelationsSchema).array(),
}))